import NamedDto from 'modules/base/dto/NamedDto';
import PiWriterFieldEditDto from './PiWriterFieldEditDto';

export class PiWriterEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.hostname = null;

		/** @type {string} */
		this.dataServerName = null;

		/** @type {string} */
		this.user = null;

		/** @type {string} */
		this.password = null;

		/** @type {string} */
		this.timezone = null;

		/** @type {number} */
		this.piWriterLog = null;

		/** @type {PiWriterFieldEditDto[]} */
		this.fields = null;

		/** @type {number} */
		this.userGroup = null;
	}

	/**
	 * @typedef {Object} _PiWriterEditDtoProps
	 * @property {string} hostname
	 * @property {string} dataServerName
	 * @property {string} user
	 * @property {string} password
	 * @property {string} timezone
	 * @property {number} piWriterLog
	 * @property {PiWriterFieldEditDto[]} fields
	 * @property {number} userGroup
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PiWriterEditDtoProps} PiWriterEditDtoProps
	 */
	/**
	 *
	 * @param {PiWriterEditDtoProps} props
	 * @returns {PiWriterEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.hostname = props.hostname;
		this.dataServerName = props.dataServerName;
		this.user = props.user;
		this.password = props.password;
		this.timezone = props.timezone;
		this.piWriterLog = props.piWriterLog;
		this.fields = props.fields !== null ? props.fields.map(d => new PiWriterFieldEditDto().setup(d)) : [];
		this.userGroup = props.userGroup;

		return this;
	}
}

export default PiWriterEditDto;
